module.exports = __webpack_public_path__ + "static/img/xlfgt.82f3763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xlfgt.png
// module id = kRgN
// module chunks = 1